const sampleCode = {
  JAVASCRIPT_CONTENT: `
async function initialize() {
  const tokenStatus = document.getElementById('token-status');
  const content = document.getElementById('content');

  try {
    const { tokenType } = await Safie.Auth.initialize();

    tokenStatus.innerText = 'valid type: ' + tokenType;
    content.style.display = '';

    if (tokenType === Safie.Auth.TokenType.AccessToken) {
      await getUserInfo();
    }
  } catch (error) {
    tokenStatus.innerText = \`\${error.type} \${error.message}\`;
  }
}

async function getUserInfo() {
  const userInfoElem = document.querySelector('.user-info');

  try {
    const userInfo = await Safie.Users.queryInformation();

    const mailAddressElem = document.querySelector('[data-name="mail-address"]');
    mailAddressElem.textContent = userInfo.mailAddress;

    const userNameElem = document.querySelector('[data-name="user-name"]');
    userNameElem.textContent = userInfo.userName;

    userInfoElem.style.display = '';
  } catch (error) {
    userInfoElem.style.display = 'none';
  }
}

async function setToken() {
  const tokenStatus = document.getElementById('token-status');
  const content = document.getElementById('content');

  const token = window.prompt('insert APIKey or AccessToken', '');
  if (token == null || token === '') {
    return;
  }

  const tokenType = token.includes('-') ? 'accessToken' : 'apiKey';

  try {
    await Safie.Auth.setToken(token, tokenType);
    tokenStatus.innerText = 'valid type: ' + tokenType;
    content.style.display = '';

    if (tokenType === 'accessToken') {
      await getUserInfo();
    }
  } catch (error) {
    tokenStatus.innerText = \`\${error.type} \${error.message}\`;
  }
}

async function removeToken() {
  const tokenStatus = document.getElementById('token-status');
  const content = document.getElementById('content');

  await Safie.Auth.removeToken();

  tokenStatus.innerText = '';
  content.style.display = 'none';

  const userInfoElem = document.querySelector('.user-info');
  userInfoElem.style.display = 'none';
}

document.addEventListener('DOMContentLoaded', initialize);

async function getDevices() {
  try {
    const result = await Safie.Devices.queryDevices();

    const select = document.getElementById('device-select');
    select.innerHTML = '';

    for (device of result.list) {
      const option = document.createElement('option');
      option.value = device.deviceId;
      option.textContent = device.setting.name;

      select.appendChild(option);
    }
  } catch (error) {
    alert(\`エラー\\ntype: \${error.type}\\nmessage: \${error.message}\`);
  }
}

async function addPlayer() {
  const select = document.getElementById('device-select');

  const template = document.getElementById('template');
  const templateClone = template.content.cloneNode(true);

  const containerElem = document.getElementById('container');
  containerElem.appendChild(templateClone);

  const container = containerElem.querySelectorAll('[data-name="container"]:last-child')[0];

  const playerElem = container.querySelector('[data-name="player"]');

  let player;
  try {
    player = new Safie.Player.StreamingPlayer(playerElem);
  } catch (error) {
    containerElem.removeChild(container);
    alert(\`エラー\ntype: \${error.type}\nmessage: \${error.message}\`);
    return;
  }

  const deviceNameSelect = select.cloneNode(true);
  const deviceNameElem = container.querySelector('[data-name="device-name"]');
  deviceNameElem.appendChild(deviceNameSelect);
  deviceNameSelect.value = select.options[select.selectedIndex].value;
  deviceNameSelect.addEventListener('change', () => {
    player.deviceId = deviceNameSelect.value;

    const calender = container.querySelector('[data-name="calender"]');
    const date = new Date(calender.value);
    const playbackRate = playbackRateSelect.options[playbackRateSelect.selectedIndex].value;
    player.play(date.getTime(), Number(playbackRate));
  });

  const removeButton = container.querySelector('[data-name="remove-button"]');
  removeButton.onclick = () => {
    player.dispose();
    container.remove();
  };

  const playButton = container.querySelector('[data-name="play-button"]');
  playButton.onclick = () => {
    if (player.status === 'paused' || player.status === 'notLoaded') {
      player.unpause();
    } else {
      player.pause();
    }
  };

  const playbackRateSelect = container.querySelector('[data-name="playback-rate"]');
  playbackRateSelect.addEventListener('change', () => {
    const playbackRate = playbackRateSelect.options[playbackRateSelect.selectedIndex].value;
    player.play(player.playTime, Number(playbackRate));
  });

  const interactionButton = container.querySelector('[data-name="interaction-button"]');
  interactionButton.onclick = () => {
    if (player.userInteractions) {
      interactionButton.innerText = 'enable interaction';
      player.userInteractions = false;
    } else {
      interactionButton.innerText = 'disable interaction';
      player.userInteractions = true;
    }
  };

  const muteButton = container.querySelector('[data-name="mute-button"]');
  muteButton.onclick = () => {
    player.muted = !player.muted;

    if (player.muted) {
      muteButton.innerText = 'unmute';
      volumeSlider.disabled = true;
    } else {
      muteButton.innerText = 'mute';
      volumeSlider.disabled = false;
    }
  };

  const liveButton = container.querySelector('[data-name="live-button"]');
  liveButton.onclick = () => {
    player.play();
  };

  const volumeSlider = container.querySelector('[data-name="volume-slider"]');
  player.volume = Number(volumeSlider.value);
  volumeSlider.addEventListener('input', e => {
    player.volume = Number(e.target.value);
  });

  const calender = container.querySelector('[data-name="calender"]');

  let isCalenderOpen = false;
  let prevDate = null;
  calender.addEventListener('blur', e => {
    if (prevDate !== e.target.value) {
      const date = new Date(e.target.value);
      const playbackRate = playbackRateSelect.options[playbackRateSelect.selectedIndex].value;
      player.play(date.getTime(), Number(playbackRate));
    }

    isCalenderOpen = false;
  });

  calender.addEventListener('focus', e => {
    isCalenderOpen = true;
    prevDate = e.target.value;
    e.stopPropagation();
  });

  player.on(Safie.Player.PlayerEvent.PLAY_TIME_CHANGE, timestamp => {
    if (!isCalenderOpen) {
      const date = new Date(timestamp);
      const newOffset = date.getTimezoneOffset();
      date.setMinutes(date.getMinutes() - newOffset);
      calender.value = date.toISOString().slice(0, -1);
    }
  });

  const statusElem = container.querySelector('[data-name="status"]');
  const playModeElem = container.querySelector('[data-name="play-mode"]');
  const errorElem = container.querySelector('[data-name="error"]');
  const errorTypeElem = container.querySelector('[data-name="error-type"]');
  const errorMessageElem = container.querySelector('[data-name="error-message"]');

  player.on(Safie.Player.PlayerEvent.STATUS_CHANGE, ({ status, context }) => {
    statusElem.innerText = status;

    if (status === Safie.Player.PlayerStatus.Error) {
      errorElem.style.display = '';
      errorTypeElem.innerText = context.error.type;
      errorMessageElem.innerText = context.error.message;
    } else {
      errorElem.style.display = 'none';
    }

    if (status === Safie.Player.PlayerStatus.Paused || player.status === Safie.Player.PlayerStatus.NotLoaded) {
      playButton.innerText = 'play';
    } else {
      playButton.innerText = 'pause';
    }

    if (status === Safie.Player.PlayerStatus.Streaming) {
      playModeElem.innerText = context.streamingMode;
      if (context.streamingMode === Safie.Player.StreamingMode.Live) {
        playbackRateSelect.value = 1;
        playbackRateSelect.disabled = true;
      } else {
        playbackRateSelect.disabled = false;
      }
    } else {
      playModeElem.innerText = Safie.Player.StreamingMode.None;
    }
  });

  statusElem.innerText = player.status;

  player.deviceId = select.value;
  player.play();
}
`,
  CSS_CONTENT: `
.header {
  display: flex;
  justify-content: space-between;
}

.token-info {
  font-size: 0.875rem;
}

.user-info {
  font-size: 0.875rem;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.border {
  margin: 0.5rem 0;
  border: solid 0.0165rem #ccc;
}

.player-area {
  margin-top: 1rem;
}

.streaming {
  display: flex;
  margin-bottom: 1rem;
}

.device-name {
  font-size: 1rem;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
}

.streaming-player {
  width: 34rem;
  aspect-ratio: 16 / 9;
}

.controls {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.info {
  margin-left: 1rem;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
}

.info_label {
  font-weight: bold;
}

.volume {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-left: auto;
  font-size: 0.875rem;
}
`,
  HTML_CONTENT(url: string) {
    return `
    <html>
      <head>
        <script src="${url}"></script>
        <script src="sample.js"></script>
        <link href="styles.css" rel="stylesheet" />
      </head>
      <body>
        <div class="header">
          <div class="token-info">
            <label>Token Status: </label>
            <label id="token-status"></label>
            <div>
              <button onclick="setToken()">Set Token</button>
              <button onclick="removeToken()">remove Token</button>
            </div>
          </div>
          <div class="user-info" style="display: none">
            <div data-name="mail-address"></div>
            <div data-name="user-name"></div>
          </div>
          </div>
          <div class="border"></div>
        </div>
        <div id="content" style="display: none">
          <div>
            <button onclick="getDevices()">load devices</button>
            <select id="device-select"></select>
            <button onclick="addPlayer()">add player</button>
          </div>
          <div id="container"></div>
          <template id="template">
            <div data-name="container">
              <div class="device-name" style="display: flex; align-items: center">
                <div data-name="device-name"></div>
                <button data-name="remove-button" style="margin-left: 0.5rem">remove</button>
              </div>
              <div class="streaming">
                <div>
                  <div data-name="player" class="streaming-player"></div>
                  <div class="controls">
                    <button data-name="play-button">play</button>
                    <button data-name="interaction-button">disable interaction</button>
                    <div class="volume">
                      <label>Volume</label>
                      <input type="range" data-name="volume-slider" min="0" max="100" value="25" />
                      <button data-name="mute-button">mute</button>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="info">
                    <label class="info_label">Play Time:</label>
                    <input type="datetime-local" step="1" data-name="calender" />
                    <button data-name="live-button">LIVE</button>
                  </div>
                  <div class="info">
                    <label class="info_label">Play Mode:</label>
                    <label data-name="play-mode"></label>
                  </div>
                  <div class="info">
                    <label class="info_label">Playback Rate:</label>
                    <select data-name="playback-rate" disabled>
                      <option value="30">x30</option>
                      <option value="10">x10</option>
                      <option value="3">x3</option>
                      <option value="1" selected>x1</option>
                      <option value="0.5">x0.5</option>
                      <option value="0.25">x0.25</option>
                    </select>
                  </div>
                  <div class="info">
                    <label class="info_label">Status:</label>
                    <label data-name="status"></label>
                  </div>
                  <div data-name="error" style="display: none">
                    <div class="info">
                      <label class="info_label">Error Code:</label>
                      <label data-name="error-type"></label>
                    </div>
                    <div class="info">
                      <label class="info_label">Error Message:</label>
                      <label data-name="error-message"></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </body>
    </html>
    `;
  },
};
export default sampleCode;
